import React from 'react'
import { Button, InputGroup, Input, InputGroupAddon } from 'reactstrap'

/*
  searchIconQ Boolean
  searchButtonQ Boolean
  searchIconText String
  placeholder String
  handleChange Function
  buttonColor String
  val String
  name String
*/

export default function UtilSearchBar(
  {searchIconQ, searchButtonQ, searchIconText, placeholder, handleChange, buttonColor, val, name}
) {
  let searchIcon = null
  let searchButton = null
  if (searchIconQ) {
    searchIcon = <i className="fa fa-search"></i>
  }
  if (searchButtonQ) {
    searchButton = (
      <InputGroupAddon addonType='prepend'>
        <Button color='primary'>{searchIcon}{` ${searchIconText}`}</Button>
      </InputGroupAddon>
    )
  }
  
  return (
    <InputGroup>
        {searchButton}
      <Input
        type='text'
        placeholder={placeholder}
        value={val}
        name={name}
        onChange={(e) => handleChange(e)}
      />
    </InputGroup>
  )
}


// WEBPACK FOOTER //
// ./src/components/Util/UtilSearchBar.js